import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { getToasterError } from 'Services/utils';
import { dcpcApi } from './dcpcApi';

const NOTIFICATION_EVENT_TYPES_TAG = 'NotificationEventTypes';

dcpcApi.enhanceEndpoints(({ addTagTypes: [NOTIFICATION_EVENT_TYPES_TAG] }));
const eventTypesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationEventTypes: builder.query({
      query: () => 'event-types',
      providesTags: [NOTIFICATION_EVENT_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типов событий', 'event-types');
        }
      },
    }),
    getEventType: builder.query({
      query: (id) => `event-types/${id}`,
      providesTags: [NOTIFICATION_EVENT_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типа событий', 'event-type');
        }
      },
    }),
    updateEventType: builder.mutation({
      query: ({ code, method, body }) => ({
        url: `event-types/${code || ''}`,
        method,
        body,
      }),
      invalidatesTags: [NOTIFICATION_EVENT_TYPES_TAG],
    }),

    updateEventTypeTemplate: builder.mutation({
      query: (body) => ({
        url: 'event-types/template',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [NOTIFICATION_EVENT_TYPES_TAG],
    }),

    getSystemCodesEventTypes: builder.query({
      // query: () => 'event-types/system-codes',
      query: () => 'event-types',
      providesTags: [NOTIFICATION_EVENT_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'системных кодов типов событий', 'et/system-codes');
        }
      },
    }),
  }),
});

export const {
  useGetNotificationEventTypesQuery,
  useGetEventTypeQuery,
  useUpdateEventTypeMutation,
  useGetSystemCodesEventTypesQuery,
  useUpdateEventTypeTemplateMutation,
} = eventTypesApi;

const eventTypesSelect = (state) => eventTypesApi.endpoints.getNotificationEventTypes.select()(state);
const eventTypesSelector = (state) => eventTypesSelect(state).data || [];

const filterNotificationEventTypesBySearchTextSelector = createSelector(
  eventTypesSelector,
  (_, searchText) => searchText,
  (notifyEventType, searchText) => ({
    columns: [
      {
        label: 'Код события',
      },
      {
        label: 'Наименование события',
      },
      // {
      //   label: 'Код шаблона',
      // },
      // {
      //   label: 'Описание шаблона',
      // },

    ],
    rows: notifyEventType.reduce((acc, cur) => {
      const {
        code, name,
      } = cur;
      const row = [code, name].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать событие',
    },
  }),
);

export const notificationEventTypesBySearchTextSelector = (searchText) => (state) => filterNotificationEventTypesBySearchTextSelector(state, searchText);
